import { api } from "./api";

/**
 * Galería de la portada.
 *
 * Antes este archivo devolvía una lista fija en código y la portada pintaba
 * 15 rutas estáticas: no había forma de cambiar el contenido sin desplegar.
 */

/** Lo que ve el visitante: solo lo publicado, en orden. */
export const fetchGalleryService = () => api.get('/public/photos', { auth: false });

/* --------------------------- Administración --------------------------- */

/** Incluye las ocultas, que el visitante no recibe. */
export const fetchPhotosAdminService = () => api.get('/admin/photo');

export const uploadPhotoService = (file, meta = {}) => {
    const formData = new FormData();
    formData.append('file', file);

    Object.entries(meta).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
        }
    });

    return api.post('/admin/photo', formData);
};

export const updatePhotoService = (id, body) => api.put(`/admin/photo/${id}`, body);

export const deletePhotoService = (id) => api.delete(`/admin/photo/${id}`);

export const reorderPhotosService = (ids) => api.put('/admin/photo/reorder', { ids });
